import * as R from 'ramda'
import { bytesToMegaBytes, kilobytesToBytes } from 'libs/file'
import { mediaType } from 'app/components/media/media'

export const isMediaDeleteKey = 'isMediaDelete'

const getActiveMediaPreview = R.compose(
  R.filter(R.o(R.isNil, R.prop('error'))),
  R.filter(R.propEq('isCancel', false)),
  R.prop('file'),
)

const mapPDf = (data) => {
  return {
    url: R.prop('url', data),
    fileName: R.prop('name', data),
    isCancel: R.prop('isCancel', data),
    fileSize: R.when(
      R.o(R.not, R.isNil),
      bytesToMegaBytes,
    )(R.prop('size', data)),
  }
}

const mapVideo = (data) => {
  return {
    url: R.prop('url', data),
  }
}

//Preview section map with NotificationMediaPropTypes.js
export const toMedia = (input) => {
  if (R.isNil(input)) return undefined

  switch (input.type) {
    case mediaType.image:
      return {
        submit: input,
        preview: {
          type: R.prop('type', input),
          content:
            getActiveMediaPreview(input).length > 0
              ? R.compose((files) => {
                  return {
                    url:
                      R.path([0, 'location'], files) ||
                      R.path([0, 'url'], files),
                    length: R.length(files),
                  }
                }, getActiveMediaPreview)(input)
              : { url: undefined, length: undefined },
        },
      }

    case mediaType.pdf:
      return {
        submit: input,
        preview: {
          type: R.prop('type', input),
          content: R.compose(
            R.ifElse(
              R.isEmpty,
              R.always({
                url: undefined,
                fileName: undefined,
                isCancel: undefined,
                fileSize: undefined,
              }),
              R.o(mapPDf, R.head),
            ),
            getActiveMediaPreview,
          )(input),
        },
      }
    case mediaType.video:
      return {
        submit: input,
        preview: {
          type: R.prop('type', input),
          content: R.compose(
            R.ifElse(
              R.isEmpty,
              R.always({ url: undefined }),
              R.o(mapVideo, R.head),
            ),
            getActiveMediaPreview,
          )(input),
        },
      }
    default:
      return input
  }
}

// This function for get initial media for DropZone
// required params: media type, media url
// export const parseMediaFromApi = (type, url, fileName, fileSize) => {

export const parseMediaFromApi = (type, media) => {
  switch (type) {
    case mediaType.image:
      return {
        type,
        file: R.map((item) => {
          return {
            ...item,
            ...{
              loading: 100,
              isLoading: false,
              isSuccess: true,
              error: undefined,
              isCancel: false,
            },
          }
        }, media),
      }
    case mediaType.pdf:
      return {
        type,
        file: R.map((item) => {
          return {
            name: item.fileName,
            size: kilobytesToBytes(item.fileSize),
            id: item.id,
            url: item.utl,
            isSuccess: true,
            error: undefined,
            isCancel: false,
          }
        }, media),
      }

    case mediaType.video:
      return {
        type,
        file: R.map((item) => {
          return {
            id: item.id,
            url: item.url,
            isSuccess: true,
            error: undefined,
            isCancel: false,
          }
        }, media),
      }

    default:
      new Error(`type: ${type} is not support cannot parse media from api`)
  }
}
